<template>
	<el-container>
		<el-header class="nav-container" style="height: auto !important;">
			<navbar 
				:nav-index="1" 
				@nav-items-click="navClick" 
				@pop-click="popClick" />
		</el-header>
		<div class="items" id="crm-main-container">
			<app-main />
		</div>
		<edit-password 
			:show="showEditPassword" 
			@close="showEditPassword=false" />
	</el-container>
</template>

<script>
	import { mapGetters } from 'vuex'
	import {
		Navbar,
		AppMain
	} from './components'
	import EditPassword from './components/EditPassword'
	

	export default {
		name: 'Layout',
		components: {
			Navbar,
			AppMain,
			EditPassword
		},

		data() {
			return {
				isCreate: false,
				createCRMType: '',
				showEditPassword: false
			}
		},
		computed: {
			...mapGetters(['allAuth', 'customerRouters']),

		},
		created() {
			if(this.allAuth.customer.message){
				this.getcrmMessagNum()
			}
			
			// this.getcrmSettingConfig()
		},

		mounted() {
			
		},

		methods: {
			navClick() {},
			popClick() {
				this.showEditPassword = true
			},
			
			/**
			 * 获取客户管理配置信息
			 */
			// getcrmSettingConfig() {
			// 	this.$store.dispatch('CRMSettingConfig')
			// },
			
			/**
			 * 获取消息数
			 */
			getcrmMessagNum() {
			  this.$store
				.dispatch('GetMessageNum')
				.then(res => {})
				.catch(() => {})
			},

			/**
			 * 新建客户同时新建联系人
			 */
			// 创建数据页面 保存成功
			createSaveSuccess(data) {
				if (data && data.saveAndCreate) {
					if (data.type == 'setting') {
						this.createCRMType = 'contacts'
						this.createActionInfo = {
							type: 'relative',
							crmType: 'setting',
							data: {}
						}
						this.createActionInfo.data['setting'] = data.data
						this.isCreate = true
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.el-container {
		min-height: 100%;
	}

	

	.nav-container {
		padding: 0;
		// box-shadow: 0px 1px 2px #dbdbdb;
		z-index: 100;
		min-width: 1200px;
	}
	.items{
		align-items: center;
		flex-direction: column; 
		min-height: 100vh;
		margin:0 auto;
	}
	
	/deep/ .p-contianer{
		background-color: #fff !important;
		padding:10px;
		position: fixed;
		bottom: 0;
		width: 1550px;
		z-index: 2001;
		border-top: 1px solid #eee;
	}
	
</style>
